import { useContext } from 'react';
import { UnleashContext } from 'global/Unleash';
import useFeatureFlagStore from 'global/Unleash/store';
import {
  UseFeatureFlagsInstanceValue,
  UseFeatureFlagsType,
} from '../../@types/unleash';

export const useFeatureFlagInstance = (): UseFeatureFlagsInstanceValue => {
  const { isReady } = useFeatureFlagStore();
  const instance = useContext(UnleashContext);
  return { instance, isReady };
};

const useFeatureFlags: UseFeatureFlagsType = (value) =>
  value
    ? useFeatureFlagStore((state) => state.flagList[value])
    : useFeatureFlagStore((state) => state.flagList);

export default useFeatureFlags;
